import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'resource-groups-search',
  templateUrl: './resource-groups-search.component.html',
  styleUrls: ['./resource-groups-search.component.scss']
})
export class ResourceGroupsSearchComponent implements OnInit {

  onApply = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<ResourceGroupsSearchComponent>, @Inject(MAT_DIALOG_DATA) public search: any) {
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.onApply.emit(this.search);
  }
}
